import React, { useEffect } from "react";
import { SingleProgressBar } from "./single-progress-bar/single-progress-bar";
import { useStatisticsStore } from "../../stores/statisticsStore";
import { Box, Typography } from "@mui/material";
import {
  containerStyle,
  rowStyle,
  nameTypographyStyle,
  valueTypographyStyle,
} from "./styles";

interface ProgressBarItem {
  name: string;
  value: number;
  total: number;
}

interface ProgressBarsBlocksProps {
  isStatic?: boolean;
}

export const ProgressBarsBlocks: React.FC<ProgressBarsBlocksProps> = ({
  isStatic = false,
}) => {
  const {
    progressBar: dynamicProgressBar,
    fetchProgressBar,
    refreshedProgressBar,
    setRefreshedProgressBar,
  } = useStatisticsStore();

  const staticProgressBar: ProgressBarItem[] = [
    { name: "Answered quiz", value: 2, total: 9 },
    { name: "Current week score", value: 0, total: 45 },
    { name: "Progress of the focus", value: 4, total: 5 },
  ];

  const progressBar = isStatic ? staticProgressBar : dynamicProgressBar;

  useEffect(() => {
    if (!isStatic && refreshedProgressBar) {
      setRefreshedProgressBar(false);
      fetchProgressBar();
    }
  }, [
    isStatic,
    refreshedProgressBar,
    fetchProgressBar,
    setRefreshedProgressBar,
  ]);

  return (
    <Box sx={containerStyle}>
      {progressBar.map((item, index) => (
        <Box key={index}>
          <Box sx={rowStyle}>
            <Typography sx={nameTypographyStyle}>{item.name}</Typography>
            <Typography sx={valueTypographyStyle}>
              {item.value} out of {item.total}
            </Typography>
          </Box>
          <SingleProgressBar value={item.value} total={item.total} />
        </Box>
      ))}
    </Box>
  );
};
